import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Row, Table } from "reactstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import { useForm, FormProvider } from "react-hook-form";
import NumberFormat from "react-number-format";
import shallow from "zustand/shallow";
import { useFromUser } from "stores/LocalStorageHelper";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus } from "constants/Constants";
import { WholesaleInvsContext } from "./WholeSaleInvsContext";
import OpenModalButton from "../../../components/OpenModalButton";
import ChildrenModal from "../../../../../components/modals/ChildrenModal";
import DealInventoryListData from "../../inventory/DealInventoryListData";

const WholeSaleInvsForm = () => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");

	const { wholesaleInvs = [], editSalesPrice } = useCurrentDealStore(
		(state) => state,
		shallow
	);
	const { type } = useCurrentDealStore((state) => state.deal, shallow);

	const { editIsLoading, toggleWholesaleInvsModal } =
		useContext(WholesaleInvsContext);

	const [add, setAdd] = useState(false);

	const toggleAdd = () => setAdd(!add);

	useEffect(() => {
		editIsLoading(false);
	}, [editIsLoading]);

	// Normalize wholesaleInvs for defaultValues
	const normalizedWholesaleInvs = wholesaleInvs.map((v) => ({
		...v,
		salesPrice: typeof v.salesPrice === "number" ? v.salesPrice : 0,
	}));

	// Validation
	const schema = yup.object().shape({
		wholesaleInvs: yup.array().of(
			yup.object().shape({
				salesPrice: yup
					.number()
					.typeError("Price must be a number")
					.min(0, "Price must be positive")
					.required("Price is required"),
			})
		),
	});

	const methods = useForm({
		defaultValues: { wholesaleInvs: normalizedWholesaleInvs },
		resolver: yupResolver(schema),
	});

	const onSubmit = () => {
		toggleWholesaleInvsModal();
	};

	return (
		<FormProvider {...methods}>
			<Form onSubmit={methods.handleSubmit(onSubmit)}>
				<Row>
					<OpenModalButton
						buttonClass="btn-lg btn btn-link"
						buttonText="Select Vehicle"
						modalTitle="Vehicles"
						onClick={toggleAdd}
						icon={true}
						iconClass="nc-icon nc-tap-01"
					/>
				</Row>

				<Table bordered responsive>
					<thead>
						<tr>
							<th>Vehicle</th>
							<th>Stock No</th>
							<th>VIN</th>
							<th>Price</th>
						</tr>
					</thead>
					<tbody>
						{normalizedWholesaleInvs.map((wholesale, index) => (
							<tr key={wholesale.car.vin}>
								<td>
									{wholesale.car.year} {wholesale.car.make}{" "}
									{wholesale.car.model}
								</td>
								<td>{wholesale.car.stockNo}</td>
								<td>{wholesale.car.vin}</td>

								<td style={{ width: "220px" }}>
									<NumberFormat
										value={wholesale?.salesPrice}
										thousandSeparator
										prefix="$"
										allowNegative={false}
										decimalScale={2}
										fixedDecimalScale
										className="form-control"
										style={{ width: "100%", minWidth: "200px" }}
										onValueChange={(values) =>
											editSalesPrice(values.floatValue ?? 0, index)
										}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</Table>

				<div style={{ display: "flex", justifyContent: "center" }}>
					<Button
						className="btn btn-md"
						type="submit"
						disabled={type !== DealStatus.PENDING}
					>
						<i className="nc-icon nc-check-2" /> Save All
					</Button>
				</div>
			</Form>

			<ChildrenModal
				modalTitle="Select Vehicle"
				modal={add}
				toggle={toggleAdd}
				children={<DealInventoryListData toggle={toggleAdd} mainForm="Bulk" />}
			/>
		</FormProvider>
	);
};

export default WholeSaleInvsForm;
